import { render, staticRenderFns } from "./crud-modal.vue?vue&type=template&id=d19b2f48&"
import script from "./crud-modal.vue?vue&type=script&lang=js&"
export * from "./crud-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports